import { defineMessages, type MessageDescriptor } from 'react-intl';

export const messages: Record<
	'backButton' | 'closeButton' | 'title' | 'subtitle' | 'recentActivityHeading' | 'seeAllActivity',
	MessageDescriptor
> = defineMessages({
	backButton: {
		id: 'ai-mate.rovo-memories.work-profile-screen.back-button',
		defaultMessage: 'Back to Rovo settings',
		description: 'Label for the back button in the work profile screen header',
	},
	closeButton: {
		id: 'ai-mate.rovo-memories.work-profile-screen.close-button',
		defaultMessage: 'Close',
		description: 'Accessible label for the close button in the work profile screen header',
	},
	title: {
		id: 'ai-mate.rovo-memories.work-profile-screen.title',
		defaultMessage: 'Work profile',
		description: 'Title of the work profile screen',
	},
	subtitle: {
		id: 'ai-mate.rovo-memories.work-profile-screen.subtitle',
		defaultMessage: 'This profile is based on your internal company data and recent activity.',
		description: 'Subtitle of the work profile screen',
	},
	recentActivityHeading: {
		id: 'ai-mate.rovo-memories.work-profile-screen.recent-activity-heading',
		defaultMessage: 'Recent activity',
		description: 'Heading for the recent activity section in the work profile screen',
	},
	seeAllActivity: {
		id: 'ai-mate.rovo-memories.work-profile-screen.see-all-activity',
		defaultMessage: 'See all activity',
		description: 'Label for the button to see all activity in the work profile screen',
	},
});
